import * as React from 'react';
import { CorePagination } from '../internal/WixUiCoreComponents/components/CorePagination';
import { ChevronLeft, ChevronRight, DoubleChevronLeft, DoubleChevronRight, } from '@wix/wix-ui-icons-common/on-stage';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { st, classes } from './Pagination.st.css';
/** Pagination component */
export const Pagination = (props) => {
    return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => {
        return (React.createElement(CorePagination, Object.assign({ previousLabel: React.createElement(ChevronLeft, null), nextLabel: React.createElement(ChevronRight, null), firstLabel: React.createElement(DoubleChevronLeft, null), lastLabel: React.createElement(DoubleChevronRight, null), rtl: rtl, showFirstLastNavButtons: props.totalPages > props.maxPagesToShow, paginationMode: mobile ? 'compact' : 'pages', slashLabel: "/" }, props, { className: st(classes.root, { mobile, rtl }, props.className) })));
    }));
};
Pagination.displayName = 'Pagination';
Pagination.defaultProps = {
    maxPagesToShow: 5,
};
//# sourceMappingURL=Pagination.js.map